import { useState } from "react";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    const target = document.getElementById("trending");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
    if (kw) {
      // highlight hint by scrolling to trending where the user can browse all神番
      window.alert?.(`正在为你搜索：「${kw}」相关下饭神番`);
    }
  };

  return (
    <section
      id="top"
      className="relative min-h-[640px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      {/* background */}
      <div
        className="absolute inset-0 bg-cover bg-center object-top"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Warm%20cheerful%20cartoon%20illustration%20of%20a%20cute%20orange%20puppy%20watching%20anime%20on%20a%20big%20tv%20and%20laughing%2C%20surrounded%20by%20floating%20popcorn%20and%20comic%20speech%20bubbles%2C%20flat%20vector%20style%2C%20vibrant%20orange%20and%20teal%20palette%2C%20soft%20cream%20background%2C%20energetic%20fun%20atmosphere&width=1600&height=900&seq=xgkp-hero-bg&orientation=landscape)",
        }}
      ></div>
      {/* warm overlay for text contrast */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-background-50"></div>

      {/* floating decorations */}
      <div className="absolute top-24 left-6 md:left-12 hidden lg:flex items-center gap-1 bg-background-50/90 rounded-full px-4 py-2 text-sm text-foreground-700 shadow-soft">
        <i className="ri-emotion-laugh-line text-primary-500 text-lg"></i>
        每集都能笑出声
      </div>
      <div className="absolute bottom-28 right-6 md:right-12 hidden lg:flex items-center gap-1 bg-background-50/90 rounded-full px-4 py-2 text-sm text-foreground-700 shadow-soft">
        <i className="ri-fire-line text-primary-500 text-lg"></i>
        本周热播中
      </div>

      {/* content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-24 md:py-28">
        <span className="inline-flex items-center gap-2 rounded-full bg-accent-500 text-background-50 px-4 py-1.5 text-sm font-bold">
          <i className="ri-magic-line"></i>
          下饭神番 · 每日更新
        </span>

        <h1 className="mt-6 text-4xl md:text-6xl font-heading text-background-50 leading-tight">
          吃饭没番看？
          <span className="text-secondary-300 block mt-2 md:mt-3">小狗看番专治不开心</span>
        </h1>

        <p className="mt-6 max-w-2xl mx-auto text-base md:text-lg text-background-100/95">
          搞笑番推荐、沙雕动画、解压爆笑日常全收录。无脑乐呵不费脑，打开小狗看番，
          立刻找到你的下饭神番，追更更方便。
        </p>

        {/* search */}
        <form
          onSubmit={handleSearch}
          className="mt-9 mx-auto max-w-xl bg-background-50 rounded-full flex items-center p-1.5 shadow-soft"
        >
          <i className="ri-search-line text-lg text-foreground-400 pl-4"></i>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="想找哪部下饭神番？试试「沙雕」"
            className="flex-1 bg-transparent border-0 outline-none text-sm text-foreground-900 px-3 py-2.5 placeholder:text-foreground-400"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 px-5 md:px-7 py-2.5 text-sm font-bold transition-colors"
          >
            立即开看
          </button>
        </form>

        {/* stats */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {[
            { num: "600+", label: "精选神番" },
            { num: "12万+", label: "追番用户" },
            { num: "4.9", label: "平均评分" },
            { num: "日更", label: "新番速递" },
          ].map((s) => (
            <div key={s.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl text-background-50">{s.num}</div>
              <div className="text-xs md:text-sm text-background-200 mt-1">{s.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}